export const SECTION_ID: Record<string, SectionType> = {
  SALE_INFO: 'saleInfo',
  ASSESSMENT: 'assessment',
  DOCUMENTS: 'documents',
  SHIPPING: 'shipping',
}

export type SectionType = 'saleInfo' | 'assessment' | 'documents' | 'shipping'
